export default __webpack_public_path__ + "static/media/edits-btn.28cbaa76.svg";